export const TrashIcon = ({
  color = '#D4002A',
  width = 17,
  height = 16,
  className,
  onClick,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <path
        d="M7.29932 6.66667V10.6667M9.96598 6.66667V10.6667M12.6327 4V12C12.6327 12.7364 12.0357 13.3333 11.2993 13.3333H5.96598C5.2296 13.3333 4.63265 12.7364 4.63265 12V4M3.29932 4H13.966M10.6326 4V3.33333C10.6326 2.59695 10.0357 2 9.29932 2H7.96598C7.2296 2 6.63265 2.59695 6.63265 3.33333V4"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
